export interface MenuArrowProps {
  className?: string;
  onClick?: () => void;
}

export default function MenuArrowIcon({ className, onClick }: MenuArrowProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      onClick={onClick}
    >
      <path
        d='M4 6L8 10L12 6'
        stroke='#666666'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
